// extracted by mini-css-extract-plugin
export var content = "content-grid-module--content--5217f";
export var contents = "content-grid-module--contents--1744a";
export var root = "content-grid-module--root--8c629";
export var title = "content-grid-module--title--834a0";
export var title__withBackground = "content-grid-module--title__with-background--33a40";